module.exports = __webpack_public_path__ + "img/galeria-pets-1.8172c9d7.jpg";